
<script>
import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props: ["data", "options"],
    mounted() {
        // Overwriting base render method with actual data.
        this.renderChart({
            labels: this.options,
            datasets: this.data
        });
    }
};
</script>


// WEBPACK FOOTER //
// chart.vue?7f6f3f9a